module.exports = __webpack_public_path__ + "static/img/slide_small4.8592f91.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/slide_small4.png
// module id = 411x
// module chunks = 5